import * as z from "zod";
import { marketSeriesSchema } from "../schemas/market";
import { defineTool } from "../tool-definition";

export const listMarketSeries = defineTool({
	name: "list_market_series",
	description:
		"The national FRED economic series Market Analytics holds, to choose codes for `get_market_series`: construction spending, housing starts, interest rates, credit conditions, employment and input prices. Each comes with its label, group, units and frequency. This is economy-wide data, not the record.",
	label: "Market series list",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "model",
	input: z.strictObject({}),
	data: z.strictObject({ items: z.array(marketSeriesSchema) }),
});
